import axios from '@/utils/request'

export default {
    // 2020-07-30
    findByTenantId() {
        return axios.get('/colors/find-by-tenant-id')
    },
    // 2020-07-30
    update(id, params) {
        return axios.put('/colors/' + id, params)
    },
    // 2020-07-30
    insertBatch(params) {
        return axios.post('/colors/insert-batch', params)
    },
    // 2020-07-30
    delete(id) {
        return axios.delete('/colors/' + id)
    }

}

